import { createSlice } from "@reduxjs/toolkit";
//initial Satte

const initialState = {
  loading: false,
};

const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    hiddeLoading: (state) => {
      state.loading = false;
    },
  },
});

export const { showLoading, hiddeLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
